// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/burger/burger-top-nav.scss
 ** module id = 39
 ** module chunks = 0 1
 **/